<template>
  <div>
    <b-card :title="$route.params.id ? $t('settings.engineeringOffice.edit') : $t('settings.engineeringOffice.add')">
      <validation-observer
        ref="form"
        #default="{ handleSubmit }"
      >
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="office_name"
                rules="required"
              >
                <b-form-group
                  label="اسم المكتب"
                  label-for="office_name"
                >
                  <b-form-input
                    id="office_name"
                    v-model="form.office_name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="registration_number"
                rules="required"
              >
                <b-form-group
                  label="رقم التسجيل"
                  label-for="registration_number"
                />
                <b-form-input
                  id="registration_number"
                  v-model="form.registration_number"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="owner_name"
                rules="required"
              >
                <b-form-group
                  label="اسم المالك"
                  label-for="owner_name"
                >
                  <b-form-input
                    id="owner_name"
                    v-model="form.owner_name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="specialization"
                rules="required"
              >
                <b-form-group
                  label="التخصص"
                  label-for="specialization"
                >
                  <v-select
                    id="specialization"
                    v-model="form.specialization"
                    :options="specializations"
                    :reduce="val => val"
                    :get-option-label="option => option"
                    placeholder="التخصص"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="phone"
                rules="required"
              >
                <b-form-group
                  label="الهاتف"
                  label-for="phone"
                >
                  <b-form-input
                    id="phone"
                    v-model="form.phone"
                    :state="errors.length > 0 ? false : null"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="email"
                rules="required"
              >
                <b-form-group
                  label="البريد الإلكتروني"
                  label-for="email"
                >
                  <b-form-input
                    id="email"
                    v-model="form.email"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="address"
                rules="required"
              >
                <b-form-group
                  label="العنوان"
                  label-for="address"
                >
                  <b-form-input
                    id="address"
                    v-model="form.address"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="governorate_id"
                rules="required"
              >
                <b-form-group
                  label="المحافظة"
                  label-for="governorate_id"
                >
                  <v-select
                    id="governorate_id"
                    v-model="form.governorate_id"
                    :options="governorates"
                    :reduce="val => val.id"

                    :get-option-label="option => option.name_ar"
                    placeholder="المحافظة"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="license_expiry_date"
                rules="required"
              >
                <b-form-group
                  label="تاريخ انتهاء الرخصة"
                  label-for="license_expiry_date"
                >
                  <flat-pickr
                    id="license_expiry_date"
                    v-model="form.license_expiry_date"
                    :state="errors.length > 0 ? false : null"
                    :config="{ dateFormat: 'Y-m-d'}"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <validation-provider
                #default="{ errors }"
                name="is_active"
              >
                <b-form-group
                  label="فعال؟"
                  label-for="is_active"
                >
                  <b-form-checkbox
                    v-model="form.is_active"
                    switch
                  >
                    {{ form.is_active ? $t('common.active') : $t('common.inactive') }}
                  </b-form-checkbox>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ $t('common.save') }}
              </b-button>
              <b-button
                variant="outline-secondary"
                class="ml-1"
                @click="$router.go(-1)"
              >
                {{ $t('common.cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components: {
    flatPickr, BCard, BForm, BRow, BCol, vSelect, BFormGroup, BFormInput, BFormCheckbox, BButton, ValidationObserver, ValidationProvider,
  },
  data() {
    return {
      form: {
        office_name: '',
        registration_number: '',
        owner_name: '',
        specialization: '',
        phone: '',
        email: '',
        address: '',
        governorate_id: '',
        license_expiry_date: '',
        is_active: false,
      },
      specializations: [
        'architecture',
        'civil',
        'mechanical',
        'electrical',
        'general',
      ],
    }
  },
  computed: {
    ...mapGetters({
      engineeringOffices: 'engineeringOffices/engineeringOffices',

      governorates: 'governorates/dropdown',
    }),
    isEdit() {
      return !!this.$route.params.id
    },
  },
  mounted() {
    this.$store.dispatch('governorates/dropdown')
    if (this.isEdit) {
      this.fetchEngineeringOffice()
    }
  },
  methods: {
    fetchEngineeringOffice() {
      this.$store.dispatch('engineeringOffices/get', this.$route.params.id)
        .then(response => {
          this.form = { ...response.data }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
        })
    },
    onSubmit() {
      console.log('this.form', this.form)
      const action = this.isEdit ? 'update' : 'create'
      const payload = this.isEdit ? { id: this.$route.params.id, data: this.form } : this.form
      console.log('payload', payload)
      this.$store.dispatch(`engineeringOffices/${action}`, payload)
        .then(() => {
          this.$swal.fire({
            title: 'تم التعديل بنجاح',
            icon: 'success',
            timer: 1500,
          })
          this.$router.push({ name: 'settings-engineering-offices' })
        })
        .catch(error => {
          this.$swal.fire({
            title: error.response.data.message,
            icon: 'error',
            timer: 1500,
          })
        })
    },
  },

}

</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
